export default __webpack_public_path__ + "static/media/f.4fe52a5c.png";